import React, { useCallback } from "react";
import { Checkbox, Grid } from "semantic-ui-react";
import styled from "styled-components";

const GridBox = styled.div`
    display: flex;
    border: 1px solid black;
    max-width: 380px;
    margin-bottom: 2em !important;
`;

const GridColBox = styled.div`
    position: relative !important;
    display: flex !important;
    min-width: 70px !important;
    justify-content: center !important;
    align-items: center !important;
    padding: 1em !important;
    &:not(:last-child) {
        border-right: 1px solid black;
    }
    ::after {
        content: attr(label);
        font-weight: bold;
        position: absolute;
        bottom: -2em;
    }
`;

const Holder = styled.div`
    padding: 1em;
    padding-bottom: 2em;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const Test4 = ({ view, setStpForm, id }) => {
    const onChange = useCallback((e, { name, checked }) => {
        setStpForm((prev) => {
            const newStpForm = { ...prev };

            newStpForm.data.forEach((item) => {
                if (item.STPTestView === view.STPTestView) {
                    item[name] = checked;
                }
            });

            return newStpForm;
        });
    }, [view]);

    return (
        <Holder id={id}>
            <GridBox columns={3}>
                <GridColBox
                    style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
                    label='0.15mm'
                >
                    <Checkbox
                        name={`STPTest4_15`}
                        onChange={onChange}
                        checked={view.STPTest4_15}
                    />
                </GridColBox>
                <GridColBox
                    style={{ backgroundColor: 'rgba(0,0,0,0.2)' }}
                    label='0.10mm'
                >
                    <Checkbox
                        name={`STPTest4_10`}
                        onChange={onChange}
                        checked={view.STPTest4_10}
                    />
                </GridColBox>
                <GridColBox label='0.05mm' >
                    <Checkbox
                        name={`STPTest4_5`}
                        onChange={onChange}
                        checked={view.STPTest4_5}
                    />
                </GridColBox>
            </GridBox>
        </Holder>
    );
}

export default Test4;
